import React from 'react'
import './Input.css'

const Input = ({
    value,
    onChange,
    placeHolder,
    type = 'primary',
    inputType = 'text',
    ...rest
}) => {

    const handleChange = (e) => {
        onChange(e?.target?.value)
    }

    return (
        <input
            autoComplete="new-password"
            type={inputType}
            className={`${type}Input`}
            value={value}
            onChange={handleChange}
            placeholder={placeHolder}
            {...rest}
        />
    )
}

export default Input